import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "react-quill/dist/quill.snow.css"; // Import the Quill CSS
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCreateCategoryMutation,
  useGetCategoryByIdQuery,
  useUpdateCategoryMutation,
} from "../../../features/api/videoCategoriesApiSlice";
import LoadingSpinner from "../../loader/Loader";

const AdminAddEditCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [editingMode, setEditingMode] = useState(false);

  const [createCategory, { isLoading }] = useCreateCategoryMutation();
  const [updateCategory, { isLoading: isUpdateCategory }] =
    useUpdateCategoryMutation();

  const { data: category, isLoading: categoryLoading } =
    useGetCategoryByIdQuery(id, {
      skip: !id, // Skip query if no invoiceId is provided
    });

  useEffect(() => {
    if (id) {
      setEditingMode(true);
    }
  }, [id]);

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      if (editingMode) {
        const response = await updateCategory({
          id,
          ...values,
        }).unwrap();
        toast.success(response?.message || "Category updated successfully!");
        navigate("/admin/categories");
      } else {
        const response = await createCategory({
          ...values,
        }).unwrap();
        toast.success(response?.message || "Category added successfully!");
        navigate("/admin/categories");
      }
    } catch (error) {
      toast.error(
        error?.data?.message || "An error occurred, please try again."
      );
    }
  };

  if (isLoading || isUpdateCategory || categoryLoading)
    return <LoadingSpinner />;

  // add schema validation
  // add schema validation
  const validateCategory = Yup.object().shape({
    name: Yup.string().required("Category name is required"),
  });

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-top-section">
        <div className="dash-top-flex">
          {editingMode ? (
            <h1 className="dashboard-title">Edit Category</h1>
          ) : (
            <h1 className="dashboard-title">Add Category</h1>
          )}
          <button onClick={() => navigate("/admin/categories")}>
            Categories
          </button>
        </div>
      </div>
      <Formik
        initialValues={{
          id,
          name: category?.name || "",
        }}
        validationSchema={validateCategory}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ isSubmitting }) => (
          <Form>
            <div>
              <label htmlFor="name">Project Category</label>
              <Field type="text" name="name" />
              <ErrorMessage name="name" component="div" className="error" />
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="form-button"
            >
              {editingMode ? "Update Project Category" : "Add Project Category"}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AdminAddEditCategory;
